import type { UseCase } from '@/core/shared'
import type { StripeRepository } from '@/core/stripe'

export const deletePaymentsAccount: UseCase<StripeRepository, 'deletePaymentsAccount'> = repository => {
  return async (groupUid) => {
    await repository.deletePaymentsAccount(groupUid)
  }
}
